import { useAuth } from 'hooks';
import { useEffect, useState } from 'react';
import { getGroups } from 'store/services/supplier';
import { SupplierGroup } from 'types';
import { Groups } from './Groups/Groups';
import styles from './OrganizationGroups.module.scss';

export interface OrganizationGroupsProps {
    /** A supplierId for the supplier that an admin user wants to view data for. */
    viewAsSupplier?: string;
}

export const OrganizationGroups = ({
    viewAsSupplier,
}: OrganizationGroupsProps) => {
    const { user } = useAuth();

    const [groups, setGroups] = useState<SupplierGroup[]>([]);

    useEffect(() => {
        if (user?.protected) {
            getGroups(viewAsSupplier ?? user?.protected?.supplierId).then(
                (groups: SupplierGroup[]) => {
                    if (groups) setGroups(groups);
                }
            );
        }
    }, [user?.protected, viewAsSupplier]);

    return (
        <div data-testid="OrganizationGroups" className={styles.container}>
            <Groups
                groups={groups}
                supplierId={viewAsSupplier ?? user?.protected?.supplierId ?? ''}
                updateGroups={setGroups}
            />
        </div>
    );
};
